module.exports = __webpack_public_path__ + "static/img/30020 (1).2d7e171.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30020 (1).webp
// module id = 3p4j
// module chunks = 14